import { Box, Dialog, DialogContent } from "@mui/material";
import React, { useState } from "react";
import WelcomeHeader from "./WelcomeHeader";
import WelcomeContent from "./WelcomeContent";
import CustomButton from "../../../components/common/button/CustomButton";

interface WelcomeScreenProps {
  open: any; // Define the 'open' prop
  onHide: () => void; // Define the 'onHide' prop
}

const WelcomeScreen: React.FC<WelcomeScreenProps> = (props) =>{
  const {open,onHide} = props;

  return (
    <Dialog open={open}
    sx={{
      '& .MuiPaper-root':{
        borderRadius:10
      }
    }}
    >
      <WelcomeHeader />
      <DialogContent
        sx={{
          scrollbarWidth: "thin",
          "&::-webkit-scrollbar": {
            width: "10px",
          },
        }}
      >
        <WelcomeContent />
        <Box sx={{ display: "flex", justifyContent: "center" , alignItems:'center'}}>
          <CustomButton
            title="Let's get started"
            onClick={onHide}
          />
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default WelcomeScreen;
